module.exports = __webpack_public_path__ + "static/lolipop-2-883cda77dcc5d8605d949ada7cde0537.jpg";